import { t, PHRASES } from '../../../translate';
var ENABLED = FOR_YANDEX || FOR_VK;
export var isSmallScreen = function () {
    return ENABLED && (window.innerWidth < 300 || window.innerHeight < 350);
};
export var drawSmallScreenMsg = function (scene, bg) {
    if (bg === void 0) { bg = '#000'; }
    if (ENABLED) {
        scene.fillRect(0, 0, scene.width, scene.height, bg);
        var height = window.innerHeight;
        if (height > 125) {
            var y0_1 = height > 350 ? height / 2 - 50 : height - 50;
            var fontSize = 15;
            var lh_1 = fontSize + 4;
            scene.save();
            scene.font(fontSize, 'Arial', 'normal');
            scene.fillStyle('rgba(75,75,75,1)');
            scene.shadowColor('rgba(255,255,255,0.5)');
            scene.shadowBlur(5);
            t(PHRASES.SMALL_SCREEN).map(function (text, i) { return scene.fillCenterText(text, y0_1 + i * lh_1); });
            scene.restore();
        }
    }
};
